import { render, staticRenderFns } from "./FormCascaderItem.vue?vue&type=template&id=4b802e2e&"
import script from "./FormCascaderItem.vue?vue&type=script&lang=js&"
export * from "./FormCascaderItem.vue?vue&type=script&lang=js&"
import style0 from "./FormCascaderItem.vue?vue&type=style&index=0&id=4b802e2e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports